import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appStrategia]'
})
export class StrategiaDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
